import React, { forwardRef, HTMLAttributes, useRef, useState } from 'react';
import { useTheme } from 'styled-components';

import { InputStructure } from '../structures/InputStructure';
import { Validator } from '@/helpers/validators';
import useEventListener from '@/hooks/eventListener';
import { useCommonStore } from '@/store';

import { ScCheckbox, ScCheckboxBlock } from './styled';

export interface CheckboxBlockProps extends HTMLAttributes<HTMLInputElement> {
  id: string;
  label: React.ReactNode;
  checked?: boolean;
  disabled?: boolean;
  error?: React.ReactNode;
  tooltip?: string;
  validate?: Validator<any, any>;
}

export const CheckboxBlock = forwardRef<HTMLInputElement, CheckboxBlockProps>(
  ({ label, error, id, tooltip, ...rest }, ref) => {
    const { images } = useTheme();

    const isMobile = useCommonStore.use.isMobileDevice();

    const tooltipRef = useRef<any>(null);

    const [isVisibleInfo, setIsVisibleInfo] = useState(false);

    useEventListener(
      'mouseenter',
      () => !isMobile && setIsVisibleInfo(true),
      tooltipRef
    );

    useEventListener(
      'mouseleave',
      () => !isMobile && setIsVisibleInfo(false),
      tooltipRef
    );

    useEventListener('click', (event) => {
      if (isMobile) {
        if (!tooltipRef.current?.contains(event.target) || isVisibleInfo) {
          setIsVisibleInfo(false);
        } else {
          setIsVisibleInfo(true);
        }
      }
    });

    return (
      <InputStructure error={error}>
        <ScCheckboxBlock>
          <label htmlFor={id}>
            <ScCheckbox>
              <input {...rest} ref={ref} id={id} type="checkbox" />
              <span className="checkbox" />
            </ScCheckbox>
            <div className="label">{label}</div>
          </label>

          {tooltip && (
            <div className="tooltip" ref={tooltipRef}>
              <span>
                <images.infoIcon.component />
              </span>
              {isVisibleInfo && (
                <div className="tooltip-content">{tooltip}</div>
              )}
            </div>
          )}
        </ScCheckboxBlock>
      </InputStructure>
    );
  }
);
